import React, { PureComponent } from "react";
import styled from "styled-components";
import { IconPlay } from "./icon-play";
import { ScrollSelector } from "./scroll-selector";
import { Screen } from "./screen";
import { AbstractTimeline } from "../abstract-timeline";
import { MINI_WIDTH, TIME_LINE_HEIGHT, PLAYER_ICON_WIDTH, PUSH_ICON_WIDTH, TIME_LINE_RADIUS, } from "./config";
import { Debounce } from "./debonce";
import { getTransparentColor } from "../../colors/default";
// tslint:disable: variable-name
const MainBackground = styled.div `
  min-width: ${MINI_WIDTH}px;
  border-radius: ${TIME_LINE_RADIUS}px;
`;
/** 左侧区域 */
const LeftStyle = styled.div `
  flex: 0 0 ${MINI_WIDTH - PUSH_ICON_WIDTH}px;
  height: ${TIME_LINE_HEIGHT}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  .year-selector{
    width: 88px;
  }
`;
/** 中间区域 */
const MiddleStyle = styled.div `
  position: relative;
  flex: 1;
  height: ${TIME_LINE_HEIGHT}px;
  overflow: hidden;
`;
/** 播放按钮 */
// tslint:disable: variable-name
const PlayerButtonStyle = styled.div `
  width: ${PLAYER_ICON_WIDTH}px;
  line-height: ${TIME_LINE_HEIGHT}px;
  text-align: center;
  margin-left: 24px;
  margin-right: 16px;
`;
/** 播放按钮点击动画 */
const PlayerButtonAnimation = PlayerButtonStyle;
/**
 * 大屏时间轴
 *
 * 基于抽象时间轴开发完成
 *
 * @author 张卓诚
 * @export
 * @class Timeline7
 * @extends {(PureComponent<TimelineSimpleProps & UIConfig & ColorProps<GlobalColorPalette> & ICSSProps, TimeLineMainState>)}
 * @implements {Color}
 * @implements {ICSS}
 */
export class Timeline7 extends PureComponent {
    constructor() {
        super(...arguments);
        /** 样式 */
        // tslint:disable-next-line: naming-convention
        this.ContainerInteraction = styled.div `
    border-radius: ${TIME_LINE_RADIUS}px;
    border: 1px solid ${getTransparentColor(this.props.colorPalette.mainColor[2], 4)};
    transition: border 0.15s;
    &:hover{
      border: 1px solid ${getTransparentColor(this.props.colorPalette.mainColor[1], 6)};
    }
    color: ${this.props.colorPalette.mainColor[5]};
  `;
        /** 样式 */
        // tslint:disable-next-line: naming-convention
        this.TimelineRootStyle = styled.div `
    min-width: ${MINI_WIDTH}px;
    border-radius: ${TIME_LINE_RADIUS}px;
    & *{
      box-sizing: border-box;
    }
  `;
        /** 样式 */
        // tslint:disable-next-line: naming-convention
        this.ContainerStyle = styled.div `
    display: flex;
    border-radius: ${TIME_LINE_RADIUS}px;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 2px 0 ${this.props.colorPalette.blackColor[2]},
      0 0 2px 0 ${this.props.colorPalette.blackColor[2]};
    .space{
      width: 9px;
    }
  `;
        /** 选择框事件 */
        this.dropMenuSelectAgent = (value, changeDateByKey) => {
            changeDateByKey(value);
        };
        /**
         * 播放状态切换
         * @param {boolean} status 当前状态
         */
        this.playAdapter = (status, play, pause) => {
            !status && play();
            status && pause();
        };
    }
    // tslint:disable-next-line: cyclomatic-complexity
    render() {
        const { colorPalette } = this.props;
        return (
        // @ts-ignore
        // tslint:disable-next-line: jsx-no-multiline-js
        React.createElement(AbstractTimeline, Object.assign({}, Object.assign({}, this.props)), (data) => (React.createElement(React.Fragment, null,
            React.createElement(this.TimelineRootStyle, { style: this.props.style, className: this.props.className },
                React.createElement(this.ContainerInteraction, null,
                    React.createElement(MainBackground, null,
                        React.createElement(this.ContainerStyle, null,
                            React.createElement(LeftStyle, null,
                                React.createElement(PlayerButtonAnimation, null,
                                    React.createElement(IconPlay, { iconInTrue: "pause-circle-2", iconInFalse: "play-circle-2", status: data.play, 
                                        // tslint:disable: jsx-no-lambda
                                        // tslint:disable-next-line: no-unbound-method
                                        onClick: () => this.playAdapter(data.play, data.letsPlay, data.pause), color: getTransparentColor(colorPalette.mainColor[2], 5), highLightColor: colorPalette.mainColor[1] })),
                                React.createElement(ScrollSelector, { className: "year-selector", datas: data.dateGrouping.map(item => ({ key: item.key, name: item.year })), selected: data.dateGrouping[data.yearIndex].key, 
                                    // tslint:disable-next-line: no-unbound-method
                                    onChange: (value) => this.dropMenuSelectAgent(value, data.changeDateByKey), colorPalette: colorPalette })),
                            React.createElement(MiddleStyle, null,
                                React.createElement(Screen, { scrollStep: 180, colorPalette: colorPalette })),
                            React.createElement("div", { className: "space" }))))),
            React.createElement(Debounce, { selected: data.key }, this.props.children)))));
    }
}
Timeline7.defaultProps = {
    interval: 4000,
    loop: "all",
};
//# sourceMappingURL=index.js.map